module.exports = __webpack_public_path__ + "manageStatic/img/d-logo1.c20d1099.png";